document.addEventListener("cart:add:variant", (event) => {
  const cartDrawer = document.querySelector('[data-component="cart-drawer"]');
  const form = document.querySelector("form.shopify-product-form");

  if (!cartDrawer && form && !form.dataset.cartFallbackSubmitted) {
    form.dataset.cartFallbackSubmitted = "true";

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: event.detail.id,
            quantity: Number(event.detail.quantity || 1),
          },
        ],
      }),
    })
      .then((response) => {
        if (!response.ok) throw new Error(`cart/add.js failed with ${response.status}`);
        return fetch(`${window.Shopify.routes.root}cart.js`);
      })
      .then((response) => {
        if (!response.ok) throw new Error(`cart.js failed with ${response.status}`);
        return response.json();
      })
      .then((cart) => {
        window.theme.cart = cart;
        document.querySelectorAll("[data-cart-count]").forEach((element) => {
          element.textContent = cart.item_count;
        });
        document.dispatchEvent(new Event("cart:updated"));
      })
      .catch(() => {
        delete form.dataset.cartFallbackSubmitted;
      });
  }
});

class ProductEstimatedDeliveryTime extends HTMLElement {
  constructor() {
    super();
    this.dom = {
      textFields: this.querySelectorAll(
        ".product__info--estimated-delivery-time",
      ),
      hiddenInput: this.querySelector('input[type="hidden"]'),
      form: document.querySelector(
        `form[id="${this.getAttribute("form-id")}"]`,
      ),
      addToCartButton: document.querySelector(
        `form[id="${this.getAttribute("form-id")}"] button[name="add"] span`,
      ),
    };

    this.settings = {
      currentInputValue: null,
      addToCartButtonText: this.getAttribute("add-to-cart-button-text"),
      addToCartButtonDefaultText: "",
      addToCartButtonQuery: `form[id="${this.getAttribute("form-id")}"] button[name="add"] span`,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  getFormFields() {
    const formId = this.getAttribute("form-id");
    return document.querySelectorAll(
      `form[id="${formId}"] input, form[id="${formId}"] select,` +
        `input[form="${formId}"], select[form="${formId}"]`,
    );
  }

  connectedCallback() {
    this.settings.addToCartButtonDefaultText =
      this.dom.addToCartButton.textContent;
    this.settings.currentInputValue = this.dom.hiddenInput.value;

    this.getFormFields().forEach((el) => {
      el.addEventListener("change", this.handleChange);
    });

    setTimeout(() => {
      this.changeAddToCartButtonText(this.settings.currentInputValue);
    }, 200);

    // Re-apply custom button text whenever the theme module overwrites it
    const button = this.dom.addToCartButton?.closest('button');
    if (button) {
      this._observer = new MutationObserver(() => {
        const currentText = button.querySelector('span')?.textContent;
        if (
          this.settings.currentInputValue &&
          currentText !== this.settings.addToCartButtonText
        ) {
          this.changeAddToCartButtonText(this.settings.currentInputValue);
        }
      });
      this._observer.observe(button, { childList: true, subtree: true });
    }
  }

  disconnectedCallback() {
    if (this._observer) this._observer.disconnect();

    if (this.dom.hiddenInput && this.dom.hiddenInput.parentNode) {
      this.dom.hiddenInput.parentNode.removeChild(this.dom.hiddenInput);
    }

    this.getFormFields().forEach((el) => {
      el.removeEventListener("change", this.handleChange);
    });
  }

  handleChange(event) {
    const variantId = event.target.value;
    this.settings.currentInputValue = null;
    if (!variantId || isNaN(variantId)) return;

    this.dom.textFields.forEach((field) => {
      field.hidden = field.dataset.id !== variantId;
      if (!field.hidden) {
        this.settings.currentInputValue = field.textContent.trim();
      }
    });

    if (this.dom.hiddenInput) {
      this.dom.hiddenInput.value = this.settings.currentInputValue ?? null;
    }

    this.changeAddToCartButtonText(this.settings.currentInputValue);
  }

  changeAddToCartButtonText(text) {
    setTimeout(() => {
        const addToCartButton = document.querySelector(this.settings.addToCartButtonQuery);
        if (!addToCartButton) return;
        if (text !== null && text !== undefined && text !== "") {
          addToCartButton.textContent = this.settings.addToCartButtonText;
        } else {
          addToCartButton.textContent = this.settings.addToCartButtonDefaultText;
        }
      }, 50);
  }
}

if (!customElements.get("estimated-delivery-time")) {
  customElements.define(
    "estimated-delivery-time",
    ProductEstimatedDeliveryTime,
  );
}

// Intercept cart/add.js fetch calls to inject line item properties from the product form.
// The theme module only passes { id, quantity } — properties are dropped — so we patch fetch.
(function () {
  const _fetch = window.fetch.bind(window);
  window.fetch = function (url, options) {
    if (
      typeof url === "string" &&
      url.includes("cart/add.js") &&
      options?.body
    ) {
      try {
        const body = JSON.parse(options.body);
        let properties = {};

        if (Array.isArray(body.items)) {
          const form = document.querySelector("form.shopify-product-form");
          if (form) {
            const formData = new FormData(form);
            for (const [key, value] of formData.entries()) {
              const match = key.match(/^properties\[(.+)\]$/);
              if (match && value) properties[match[1]] = value;
            }
            if (Object.keys(properties).length > 0) {
              body.items = body.items.map((item) => ({ ...item, properties }));
              options = { ...options, body: JSON.stringify(body) };
            }
          }
        }
      } catch (_) {}
    }

    return _fetch(url, options);
  };
})();
